// React Imports
import React, { isValidElement, useEffect, useState } from "react"

// Packge Imports
import { observer } from "mobx-react"
import { Col, Modal, Row, Toast } from "react-bootstrap"

// Project Imports
import { Button as UiButton } from "components"
import { FamilyIcon, CheckSecondaryImg, CloseIconBlack } from "constants/Images"
import FamilyMemberCardInModal from "./FamilyMemberCardInModal"
import FamilyMemberTypeEnum from "../FamilymemberTypeEnum"
import { checkIsMemberFieldSelected, updateValue, validationOtherFieldMembers,setSecondaryLa } from '../form/utils'

// CSS Imports
import "./add-member-card-modal.css"
import FamilyDetailsFormController from "../form/controller"
import AuthStore from "modules/login/store/AuthStore"
import { toJS } from "mobx"
import AccordionWithRaadioButton from "components/ui/accordion-with-radio-button/ AccordionWithRaadioButton"
import { join, upperCase } from "lodash"


const AddMemberCardModal = (props) => {

  const { show, onHide, formController, familymemberList, updateValues } = props
  const [showDoneButton, setShowDoneButton] = useState(true);
  const [showAddButton, setShowAddButton] = useState(false);
  const [showDonePopUp, setShowDonePopUp] = useState(false);
  const [donechange, setDoneChanges] = useState(false)

  let selfMemberDetails = {}
  let spouseMemberDetails = {}
  let childMemberDetails = []
  let elderlyMemberDetails = []
  let adultChildDetails = []
  let grandChildDetails = []
  let memberArray = []
  let listOfSelectedMember = []

  useEffect(() => {
    let checkAllFields = checkIsMemberFieldSelected(formController, donechange)
    // if (checkAllFields) {
    //   setShowAddButton(true)
    //   setShowDoneButton(false)
    // }
  }, [show])

  // useEffect(() => {
  //   if (showDonePopUp) {
  //     if (listOfSelectedMember.length != 0) {
  //       global.showToast('danger', `${listOfSelectedMember.join(" , ")}  Have been successfully Saved `)
  //     }
  //     setShowDonePopUp(false)
  //   }
  // }, [showDoneButton])

  if (familymemberList.length === 0) {
    return null
  }

  for (const [key, value] of Object.entries(familymemberList)) {
    if (key === "self") {
      selfMemberDetails = {
        key: key,
        value: value
      }
    }


    if (key === "spouse") {
      spouseMemberDetails = {
        key: key,
        value: value
      }
    }

    if (key.startsWith("child")) {
      childMemberDetails.push({
        key: key,
        value: value

      })
    }

    if (key == 'grand_father' || key == 'grand_mother') {
      elderlyMemberDetails.push({
        key: key,
        value: value
      })
    }

    if (key.startsWith("adult_child")) {
      adultChildDetails.push({
        key: key,
        value: value
      })
    }

    if (key.startsWith("grand_child")) {
      grandChildDetails.push({
        key: key,
        value: value
      })
    }

  }

  for (const item of Object.entries(familymemberList)) {
    // if any validation in members fields
    let memberName = item[0] === 'grand_mother' ? 'mother' : item[0] === 'grand_father' ? 'father' : item[0]
    if (item[1].hasError && !memberArray.includes(memberName.replaceAll('_', " ")) && memberName !== "other") {
      memberArray.push(memberName.replaceAll('_', " "))
    }
    // check selected members 
    if (item[1].value.is_member_selected) {
      let firstName = formController.$("members").$(item[0]).$('first_name').value
      if (!listOfSelectedMember.includes(firstName)) {
        listOfSelectedMember.push(firstName)
      }
    }
  }

  const handleDoneClick = (formController) => {
    setDoneChanges(true)
    let isvalid = validationOtherFieldMembers(formController)

    // if (isvalid) {
    if (checkIsMemberFieldSelected(formController, true) && isvalid) {
      setSecondaryLa(formController)
      props.onAddMember(onHide)
      // setShowDoneButton(false);
      // setShowAddButton(true);
      // setShowDonePopUp(true)
      // if (listOfSelectedMember.length != 0) {
      //   global.showToast('danger', `${listOfSelectedMember.join(" , ")}   Have been successfully Added `)
      // }
      //} 
      // else {
      //   setShowDoneButton(true);
      //   setShowAddButton(false);
      // }
    }
  };

  // const handleAddClick = () => {

  // };

  const handleDoneButton = (childState) => {
    setShowDoneButton(childState)
    setShowAddButton(!childState)
  };
  return (
    <div className="add-member-card-modal">
      <Modal
        className="date-picker-modal left-bottom-swipe-modal"
        show={show}
        onHide={onHide}
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header
          closeButton={false}
          className="pb-0 mx-md-2 border-bottom-0"
        >
          <Modal.Title className="text-primary-title-label-color">
            <img
              src={FamilyIcon}
              alt="family-icon"
              className="add-family-member-card-modal-top-img"
            />
            <span style={{ color: "#DF6336", fontSize: "18px" }}>Family Members</span>
          </Modal.Title>

          <div className="d-flex mt-2 pt-1">
            <UiButton variant='' className='d-inline-flex align-items-center p-0' onClick={() => handleDoneClick(formController)}>
              <img src={CheckSecondaryImg} alt='checked-icon' className='fm-modal-btn-icon font-weight-bold' />
              <p className='mb-0 font-size-16 font-size-md-12 font-weight-bold text-secondary pl-1'>Add</p>
            </UiButton>
            <UiButton variant='' className='d-inline-flex align-items-center p-0 ml-2' onClick={() => onHide()}>
              <img src={CloseIconBlack} alt='close-icon' className='fm-modal-btn-icon font-weight-bold' />
              <p className='mb-0 font-size-16 font-size-md-12 font-weight-bold pl-1'>Cancel</p>
            </UiButton>

          </div>
        </Modal.Header>
        <Modal.Body className="px-1 overflow-auto py-2 add-family-member-card">

          {(memberArray.length > 0) && <div className="px-2 text-danger "> Please scroll down to check error in  <span className="text-capitalize">{memberArray.join(", ")}</span> </div>}

          <FamilyMemberCardInModal
            memberId={1}
            familyMemberName={selfMemberDetails.key}
            data={selfMemberDetails.value}
            formController={formController}
            updateValues={updateValue}
            childList={childMemberDetails}
            grandChildList={grandChildDetails}
            onDoneButtonChange={handleDoneButton}
            isdone={showDoneButton}
            checkDoneChange={donechange}
          />

          <FamilyMemberCardInModal
            memberId={2}
            familyMemberName={spouseMemberDetails.key}
            data={spouseMemberDetails.value}
            formController={formController}
            updateValues={updateValue}
            selfList={selfMemberDetails.value}
            childList={childMemberDetails}
            grandChildList={grandChildDetails}
            onDoneButtonChange={handleDoneButton}
            isdone={showDoneButton}
            checkDoneChange={donechange}
          />

          {
            childMemberDetails.map((item, index) => {
              return (

                <FamilyMemberCardInModal
                  memberId={30 + index}
                  key={index}
                  indexofChild={index}
                  familyMemberName={item.key}
                  data={item.value}
                  formController={formController}
                  updateValues={updateValue}
                  childList={childMemberDetails}
                  grandChildList={grandChildDetails}
                  onDoneButtonChange={handleDoneButton}
                  isdone={showDoneButton}
                  checkDoneChange={donechange}
                />
              )
            })
          }

          {

            elderlyMemberDetails.map((item, index) => {
              return (

                <FamilyMemberCardInModal
                  memberId={40 + index}
                  key={index}
                  familyMemberName={item.key}
                  data={item.value}
                  formController={formController}
                  updateValues={updateValue}
                  childList={childMemberDetails}
                  grandChildList={grandChildDetails}
                  onDoneButtonChange={handleDoneButton}
                  isdone={showDoneButton}
                  checkDoneChange={donechange}                />
              )
            })
          }

          {/* {

            adultChildDetails.map((item, index) => {
              return (
                <FamilyMemberCardInModal
                  key={index}
                  familyMemberName={item.key}
                  data={item.value}
                  formController={formController}
                  updateValues={updateValue}
                  childList={childMemberDetails}
                  grandChildList={grandChildDetails}
                  onDoneButtonChange={handleDoneButton}
                />
              )
            })
          } */}

          {grandChildDetails.map((item, index) => {
            return (
              <FamilyMemberCardInModal
                memberId={50 + index}
                key={index}
                indexofGrandChild={index}
                familyMemberName={item.key}
                data={item.value}
                formController={formController}
                updateValues={updateValue}
                childList={childMemberDetails}
                grandChildList={grandChildDetails}
                onDoneButtonChange={handleDoneButton}
                isdone={showDoneButton}
                checkDoneChange={donechange}
              />
            )
          })
          }

        </Modal.Body>
      </Modal>
    </div >
  )
}

export default observer(AddMemberCardModal)
